export const DEV_SERVER_URL = "https://shanenli-server.fly.dev";
export const PROD_SERVER_URL = "https://shanenli-server-prod.fly.dev";
export const LOCAL_SERVER_URL = "http://localhost:3000/";
